import React, { Component } from 'react';
import { getObject} from "../../api"
import AvatarDisplay from "../../common/avatarDisplay"
import moment from 'moment';

import '../../index.scss';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true
        }
    }

    loadUser = () => {
        this.setState({ loading: true});
        if (this.props.uid) {
            getObject('user', this.props.uid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ userProfile: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadUser();        
    }

    render(){
        if (this.state.loading) { return null; }
        const { userProfile } = this.state;
        const {competitor, tData} = this.props;

        return (
            <>
                <div className="col-sm-3 col-md-2">
                    <AvatarDisplay userId={userProfile._id} 
                        prefix={userProfile.displayname || (competitor && competitor.displayname)}
                        suffix={competitor ? competitor.role : "Judge"}                        
                        suffix2={competitor  && tData.useSpeechTimeslots ? moment(competitor.timeSlot).format('LT') : null}                        
                    />                                                                                                                               
                </div>
                <div className="col-xs-12 col-sm-1 d-sm-none"><hr/></div>

            </>    
        )
    }
}

export default Profile;
